module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_2000_3000.ceb840d0.png";